import DataModel from './DataModel';
import { useRecoilState, useRecoilValue } from 'recoil';
import { dailyStateAtom, isAuthAtom } from '../../State';
import isElectron from '../../Global';
export default function AddAccess(type, action, detail, roomID, localSessionID) {
  const isAuthState = false; //useRecoilValue(isAuthAtom);

  var tempUserID = null;
  if (isAuthState == false) {
    if (localStorage.getItem('tempUserID') == null) {
      let rand = parseInt(Math.random() * 100000000000);
      localStorage.setItem('tempUserID', String(rand));
      tempUserID = String(rand);
    } else {
      tempUserID = localStorage.getItem('tempUserID');
    }
  }

  //遅延させる
  setTimeout(() => {
    DataModel.addAccess(type, action, detail, tempUserID, roomID, localSessionID, isElectron);
  }, 2000);

  return false;
}
